<template>
  <div>
    <div class="sayfahead tek">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="tableDisplay" class="YeniBtn">
        <el-button type="primary" size="small" @click="TopluFatura"
                   icon="el-icon-success">Toplu Gönder
        </el-button>
        <el-button type="success" size="small" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">

          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="3">
              <el-form-item label="Durum" prop="Durum">
                <el-select v-model="Form.Durum" filterable @change="Getir">
                  <el-option
                    label="Bekleyen"
                    value="0">
                  </el-option>
                  <el-option
                    label="Fatura Kesilmiş"
                    value="1">
                  </el-option>
                  <el-option
                    label="Yoksayılmış"
                    value="2">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="14">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
            v-if="tableDisplay"
            class="table-xs yazdirma"
            :data="tableData"
            style="width: 100%"
            width="100%"
            :height="Height"
            show-summary
            :summary-method="TableFooter"
          >
            <el-table-column
              label="İşlem Tarihi"
              prop="Tarih"
              width="150">
            </el-table-column>
            <el-table-column
              label="Ünvan"
              prop="Unvan"
              width="300">
            </el-table-column>
            <el-table-column
              label="Cari Bilgi"
              prop="Entegre">
            </el-table-column>
            <el-table-column
              label="Vergi Dairesi"
              prop="vDaire"
              width="150">
            </el-table-column>
            <el-table-column
              label="Vergi No"
              prop="vNo"
              width="150">
            </el-table-column>
            <el-table-column
              label="Fatura Tutarı"
              prop="Tutar"
              width="100"
              align="right">
            </el-table-column>
            <el-table-column
              label="İşlem"
              width="120"
              align="right"
              v-if="Form.Durum!='2'"
            >
              <template slot-scope="scope">

                <el-tooltip v-if="scope.row.eFaturaLink" class="item" effect="dark" content="EFatura Yazdır"
                            placement="top">
                  <el-button
                    @click.native.prevent="EFaturaYazdir(scope.row.eFaturaLink)"
                    type="text"
                    size="large">
                    <i class="feather-printer text-success"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip v-if="!scope.row.eFaturaLink && Form.Durum==0" class="item" effect="dark"
                            content="Faturasız Onayla"
                            placement="top">
                  <el-button
                    @click.native.prevent="Durum(scope.row.id,1,scope.row.Tutar)"
                    type="text"
                    size="large">
                    <i class="el-icon-success text-primary"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip v-if="!scope.row.eFaturaLink" class="item" effect="dark"
                            content="Onayla ve E-Fatura Oluştur"
                            placement="top">
                  <el-button
                    @click.native.prevent="FaturaGonder(scope.row.id,scope.row.Tutar)"
                    type="text"
                    size="large">
                    <i class="el-icon-success text-success"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip v-if="Form.Durum==0" class="item" effect="dark" content="Yoksay"
                            placement="top">
                  <el-button
                    @click.native.prevent="Durum(scope.row.id,2)"
                    type="text"
                    size="small">
                    <i class="el-icon-error text-danger"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <div class="yazdirtable" v-html="FaturaHtml"></div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import Yukleniyor from "../../components/Doc/Yukleniyor";
import axios from "axios";

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));


export default {
  components: {Yukleniyor},
  data() {
    return {
      Height: 0,
      lo: false,
      Yetki: false,
      Kaydet: false,
      Sayfa: {
        Adi: 'Sayaç Fatura Dökümü',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Tarih: [],
        Durum: "0"
      },
      FormHata: {
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Durum: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      tableData: [],
      ExcelData: [],
      tableDisplay: false,
      AltToplam: 0,
      Modal: null,
      FaturaToken: null,
      TopluData: null,
      FaturaHtml: null,
      windowRef: null,
    }
  },
  methods: {

    FaturaGonder(id, Tutar) {
      this.$prompt('E-Fatura api sistemine gönderilerek muhasebeleştirilecektir onaylıyormusunuz ? Tutarı düzenleyebilirsiniz.', 'E-Fatura Onayı', {
        confirmButtonText: 'Onayla',
        cancelButtonText: 'Vazgeç',
        inputValue: Tutar,
        inputPlaceholder: 'Fatura Tutarı'
      }).then(({value}) => {
        this.EFatura(id, value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'İptal Edildi'
        });
      });
    },
    TopluFatura(){

      this.$confirm('E-Fatura api sistemine gönderilerek muhasebeleştirilecektir onaylıyormusunuz ? ', 'Toplu E-Fatura Onayı', {
        confirmButtonText: 'Onayla',
        cancelButtonText: 'Vazgeç',
      }).then(() => {
        this.EFatura('T',this.TopluData)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'İptal Edildi'
        });
      });


    },
    eFaturaGonder(id) {
      this.$alert('E-Fatura api sistemine gönderilerek muhasebeleştirilecektir onaylıyormusunuz ?', 'E-Fatura Onayı', {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        dangerouslyUseHTMLString: true,
      }).then(() => {
        this.EFatura(id)
      });
    },
    EFatura(id, Tutar) {
      this.lo = true;
      this.$store.dispatch("Post", {Tutar: Tutar, path: '_a/efatura/' + id})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.Getir();
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    EFaturaYazdir(id) {
      this.$store.dispatch("Get", {path: '_a/faturagetir/' + id})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {

            this.windowRef = window.open(
              "",
              "",
              "width=800,height=500,left=100,top=100"
            );
            this.windowRef.document.write(response.Html);
            this.windowRef.addEventListener("beforeunload", this.Getir);
            this.windowRef.focus();
            this.windowRef.print();
            //this.windowRef.close();
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    Durum(id, Durum, Tutar = 0) {
      if (Durum === 1) {

        this.$prompt('Fatura onaylanarak muhasebeleştirilecektir onaylıyormusunuz? Tutarı düzenleyebilirsiniz.', 'Fatura Onayı', {
          confirmButtonText: 'Onayla',
          cancelButtonText: 'Vazgeç',
          inputValue: Tutar,
          inputPlaceholder: 'Fatura Tutarı'
        }).then(({value}) => {
          this.Onay(id, Durum, value)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'İptal Edildi'
          });
        });
      } else {
        this.$alert('Fatura durumu güncellenecek.', 'Durum değişikliği için onaylayınız', {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          dangerouslyUseHTMLString: true,
        }).then(() => {
          this.Onay(id, Durum)
        });
      }
    },
    Onay(id, Durum, Tutar) {
      this.$store.dispatch("Post", {Tutar: Tutar, path: '_a/faturadurum/' + id + '/' + Durum})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.Getir();
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    TableFooter() {
      const sums = [];
      sums[6] = this.AltToplam;
      return sums;
    },
    Excel(evt) {

      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 15},
        {wch: 50},
        {wch: 20},
        {wch: 20},
        {wch: 50},
        {wch: 50},
        {wch: 10},
      ];

      wb.Props = {
        Title: this.Sayfa.Adi,
        Author: "Aidatim APP",
        Manager: "Aidatim APP",
        Company: "Aidatim",
        Category: "Finans",
        Keywords: "Aidatim",
        Comments: this.Sayfa.Adi,
      };

      XLSX.utils.book_append_sheet(wb, ws, this.DefterTur);
      XLSX.writeFile(wb, this.Sayfa.Adi + ".xlsx");

    },
    Yazdir() {
      window.print();
    },
    Getir() {
      this.FaturaHtml = null;
      this.tableDisplay = false;
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: '_a/faturaliste'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.tableData = response.tableData;
                this.AltToplam = response.AltToplam;
                this.ExcelData = response.ExcelData;
                this.TopluData = response.TopluData;

                if (this.tableData)
                  this.tableDisplay = true;
                else
                  this.$message.error("Kayıt Bulunamadı");

                this.Height = '72vh';
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })
    },
    SayfaYukle() {
    },

  },
  created() {
    this.SayfaYukle();
    var Gun = new Date();
    this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    //this.Form.Tarih[0] = new Date();
    //this.Form.Tarih[1] = new Date();
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/_a/Fatura.vue